import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedContact } from '@repo/redux/actions/ui';
import {
  addContactPermissionForSharee,
  addContactPublicPermission,
  fetchContactShareStatus,
  removeContactPermissionForSharee,
  removeContactPublicPermission,
  shareContactPublicly,
  shareContactWithEmail,
  unshareContactPublicly,
  unshareContactWithSharee,
} from '@repo/redux/actions/shareStatuses/contacts';
import { Pill } from '@repo/components/containers';

import { selectSelectedContactShareStatus } from '@repo/redux/reducers/data/shareStatuses/contacts';
import analytics from '@repo/utils/helpers/analytics';
import ShareResourceModal from './ShareResource';

export default function ShareContactModal({ closeModal }: { closeModal: () => void }) {
  const dispatch = useDispatch();
  const contact = useSelector(selectSelectedContact);
  const contactShareStatus = useSelector(selectSelectedContactShareStatus);

  useEffect(() => {
    if (!contactShareStatus.isLoaded) {
      dispatch(fetchContactShareStatus(contact.id));
    }
  }, []);

  useEffect(() => {
    analytics.track('Profile Share Tapped');
  }, []);

  return (
    <ShareResourceModal
      closeModal={closeModal}
      sharedResourceType="contact"
      shareStatus={contactShareStatus}
      sharedResourcePill={<Pill contact={contact} maxWidth={160} />}
      sharePublicly={() => dispatch(shareContactPublicly(contactShareStatus))}
      unsharePublicly={() => dispatch(unshareContactPublicly(contactShareStatus))}
      addPublicPermission={(permission) =>
        dispatch(addContactPublicPermission(contactShareStatus, permission))
      }
      removePublicPermission={(permission) =>
        dispatch(removeContactPublicPermission(contactShareStatus, permission))
      }
      shareWithEmail={(email) =>
        dispatch(shareContactWithEmail({ sharedResourceID: contact.id, email }))
      }
      unshareWithSharee={(sharee) =>
        dispatch(unshareContactWithSharee({ sharedResourceID: contact.id, sharee }))
      }
      addShareePermission={(sharee, permission) =>
        dispatch(
          addContactPermissionForSharee({ sharedResourceID: contact.id, sharee, permission }),
        )
      }
      removeShareePermission={(sharee, permission) =>
        dispatch(
          removeContactPermissionForSharee({ sharedResourceID: contact.id, sharee, permission }),
        )
      }
    />
  );
}
